import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Dropdown, Button } from "antd";
import { GlobalOutlined } from "@ant-design/icons";

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const languages = [
    {
      key: "pt",
      label: "Português",
      flag: "🇵🇹",
    },
    {
      key: "en",
      label: "English",
      flag: "🇬🇧",
    },
    {
      key: "es",
      label: "Español",
      flag: "🇪🇸",
    },
    {
      key: "fr",
      label: "Français",
      flag: "🇫🇷",
    },
  ];

  useEffect(() => {
    const storedLanguage = localStorage.getItem("i18nextLng");
    if (
      storedLanguage &&
      ["pt", "en", "es", "fr"].includes(storedLanguage) &&
      storedLanguage !== i18n.language
    ) {
      i18n.changeLanguage(storedLanguage);
    }

    const handleStorageChange = (e) => {
      if (
        e.key === "i18nextLng" &&
        e.newValue &&
        ["pt", "en", "es", "fr"].includes(e.newValue) &&
        e.newValue !== i18n.language
      ) {
        i18n.changeLanguage(e.newValue);
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [i18n]);

  const currentLanguage =
    languages.find((lang) => lang.key === i18n.language) || languages[0];

  const handleLanguageChange = ({ key }) => {
      localStorage.setItem("i18nextLng", key);
      i18n.changeLanguage(key);
  };

  const menuItems = languages.map((lang) => ({
    key: lang.key,
    label: (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <span>{lang.flag}</span>
        <span>{lang.label}</span>
      </div>
    ),
  }));

  return (
    <Dropdown
      menu={{
        items: menuItems,
        onClick: handleLanguageChange,
        selectedKeys: [currentLanguage.key],
      }}
      trigger={["click"]}
      placement="bottomRight"
    >
      <Button
        type="text"
        //icon={<GlobalOutlined />}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
          color: "inherit",
          padding: "4px 8px",
        }}
      >
        <GlobalOutlined />
        <span style={{ fontSize: "12px", textTransform: "uppercase" }}>
          {currentLanguage.key}
        </span>
      </Button>
    </Dropdown>
  );
};

export default LanguageSelector;
